export default __webpack_public_path__ + "static/media/matic.c739daeb.webp";